export default __webpack_public_path__ + "static/media/匯出.1e5d6ccb.svg";